module.exports = __webpack_public_path__ + "img/info-icons.b294a45c.svg";